import { User, UserDto } from '@web-portal/domains/shared/domain-models';
import { UserBuilder } from '@web-portal/domains/user/user-seatmap';

export class UserMapper {
  static mapToUser(userData: unknown): User | void {
    if (!UserMapper.isUserDto(userData)) {
      console.warn('Invalid user data', userData);
      return;
    }

    const userBuilder = new UserBuilder()
      .withEmail(userData.email)
      .withFirstName(userData.given_name)
      .withLastName(userData.family_name)
      .withInitials();

    return userBuilder.build();
  }

  static isUserDto(userData: unknown): userData is UserDto {
    return (
      typeof userData === 'object' &&
      userData !== null &&
      'sub' in userData &&
      'email_verified' in userData &&
      'given_name' in userData &&
      'family_name' in userData &&
      'email' in userData
    );
  }
}
